import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Search, Flame, Users, BriefcaseBusiness, Gamepad2, Car, ArrowRight } from "lucide-react";
import { EXPERIENCE_SECTIONS } from "./experiencesData";
import "../components/ayaMenu.css";

const SECTION_ICONS = { phares: Flame, communaute: Users, pro: BriefcaseBusiness, loisirs: Gamepad2, mobilite: Car };
const SECTION_COLORS = { phares: "#F97316", communaute: "#34D399", pro: "#F5C445", loisirs: "#F87171", mobilite: "#34D399" };

export default function ExperiencesPage() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [collapsed, setCollapsed] = useState({});

  const q = query.trim().toLowerCase();
  const sections = EXPERIENCE_SECTIONS.map((s) => ({
    ...s,
    items: q ? s.items.filter((i) => (i.title + i.desc).toLowerCase().includes(q)) : s.items,
  })).filter((s) => s.items.length > 0);

  return (
    <div style={P.page} data-testid="experiences-page">
      <div style={P.container}>
        <div style={{ display: "flex", gap: 11, alignItems: "flex-start", marginBottom: 12 }}>
          <button className="am-close" data-testid="experiences-back" aria-label="Retour" onClick={() => navigate(-1)} style={{ marginLeft: 0 }}>
            <ChevronLeft size={17} />
          </button>
          <div>
            <h1 style={P.title}>Toutes les expériences <span style={{ color: "#34D399" }}>AYA</span></h1>
            <p style={P.sub}>Découvrez toutes les façons de vivre, créer, partager et entreprendre avec AYA.</p>
          </div>
        </div>

        <div style={P.search}>
          <Search size={15} color="#9DB4A6" />
          <input style={P.searchInput} data-testid="experiences-search" placeholder="Rechercher une expérience..."
            value={query} onChange={(e) => setQuery(e.target.value)} />
        </div>

        {sections.map((s) => {
          const SIcon = SECTION_ICONS[s.id];
          const isCollapsed = collapsed[s.id];
          return (
            <section key={s.id} style={{ marginTop: 16 }} data-testid={`experiences-section-${s.id}`}>
              <div style={P.secHead}>
                <SIcon size={15} color={SECTION_COLORS[s.id]} />
                <h2 style={P.secTitle}>{s.title}</h2>
                <button style={P.toggle} data-testid={`experiences-toggle-${s.id}`}
                  onClick={() => setCollapsed((c) => ({ ...c, [s.id]: !c[s.id] }))}>
                  {isCollapsed ? <>Voir plus <ChevronDown size={12} /></> : <>Voir moins <ChevronUp size={12} /></>}
                </button>
              </div>
              {!isCollapsed && (
                <div className="am-grid">
                  {s.items.map((e) => (
                    <button key={e.id} className="am-exp" data-testid={`experiences-card-${e.id}`} onClick={() => navigate(e.route)}>
                      <img src={e.img} alt="" className="bg" loading="lazy" />
                      {e.badge && <span className="am-live-badge">● {e.badge}</span>}
                      <e.Icon size={22} color={e.color} strokeWidth={2.2} />
                      <h3>{e.title}</h3>
                      <p>{e.desc}</p>
                      <span className="arrow"><ChevronRight size={12} color="#fff" /></span>
                    </button>
                  ))}
                </div>
              )}
            </section>
          );
        })}

        <div className="am-pro" data-testid="experiences-pro-card" style={{ marginTop: 18 }}>
          <div className="t">
            <h3>Devenez Pro</h3>
            <p>Développez votre activité avec AYA et accédez à des outils puissants.</p>
            <button className="am-pro-btn" data-testid="experiences-pro-btn" onClick={() => navigate("/inscription-pro")}>
              Créer mon espace Pro <ArrowRight size={12} />
            </button>
          </div>
          <img src="/aya/experiences/exp_pro.jpg" alt="Commerçante AYA Pro" loading="lazy" />
        </div>
      </div>
    </div>
  );
}

const P = {
  page: { minHeight: "100vh", background: "radial-gradient(ellipse at top, #072115 0%, #04120B 60%, #030B07 100%)", color: "#ECF5EE", padding: "14px 0 26px" },
  container: { maxWidth: 560, margin: "0 auto", padding: "0 14px" },
  title: { fontSize: 19, fontWeight: 900, margin: 0, color: "#fff", lineHeight: 1.15 },
  sub: { fontSize: 11, color: "#9DB4A6", margin: "4px 0 0", lineHeight: 1.4 },
  search: { display: "flex", alignItems: "center", gap: 8, height: 42, padding: "0 14px", borderRadius: 999, background: "rgba(6,34,22,0.9)", border: "1.5px solid rgba(16,185,129,0.45)" },
  searchInput: { flex: 1, background: "transparent", border: "none", outline: "none", color: "#ECF5EE", fontSize: 13, minWidth: 0 },
  secHead: { display: "flex", alignItems: "center", gap: 7, marginBottom: 9 },
  secTitle: { fontSize: 14.5, fontWeight: 900, margin: 0, color: "#fff", flex: 1 },
  toggle: { display: "inline-flex", alignItems: "center", gap: 3, background: "none", border: "none", color: "#34D399", fontSize: 11, fontWeight: 800, cursor: "pointer" },
};
